<template>
    <div class="mx-3">
        <delete-confirmation name="contact" @confirm="deleteContact"></delete-confirmation>
        <div class="row border-bottom mx-1">
            <div class="h2 col">Contacts</div>
            <div class="ml-auto">
                <a class="btn btn-primary" href="/provider/contacts/new" title="Add Contact"><i class="fas fa-address-card fa-lg"></i></a>
            </div>            
        </div>
        <div class="row mt-3 mb-1">
            <div class="input-group col-md-4 ml-auto">
                <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                </div>
                <input type="text" class="form-control" placeholder="Search" v-model="searchString">
            </div> 
        </div>
        <div v-if="contacts.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Company</th>
                        <th>Title</th>                 
                        <th>Phone</th>
                        <th>Fax</th>
                        <th v-if="showClient">Client</th>                     
                        <th></th>
                    </tr>
                </thead>
                <tbody>         
                    <tr v-for="contact in filteredContacts" :key="contact.id">
                        <td>{{ contact.name }}</td>
                        <td>{{ contact.company }}</td>
                        <td>{{ contact.title }}</td>
                        <td>{{ contact.telephone | telephone }}</td>
                        <td>{{ contact.fax | telephone }}</td>
                        <td v-if="showClient">{{ contact.client_name }}</td>
                        <td class="text-right">                   
                            <a class="mr-3" :href="'/provider/contacts/' + contact.id" title="Edit Contact"><i class="fas fa-edit fa-lg"></i></a>
                            <a href="javascript:void(0)" class="mr-2" @click="confirmDelete(contact.id)"><i class="fas fa-trash-alt fa-lg"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="pt-3 border-top">
            <h2 class="text-muted text-center">No contacts have been added.</h2>
        </div>           
    </div>   
</template>

<script>
export default {
    data() {
        return {
            contacts: [],
            isLoading: true,
            searchString: ''
        }
    },
    computed: {
        showClient: function () {
            return ([...new Set(this.contacts.map(e => e.client_name))]).length > 1;
        },
        filteredContacts: function () {
            var self = this;
            return self.contacts.filter(function (contact) {
                return (
                    contact.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1 ||
                    (contact.company && contact.company.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1)
                );
            });            
        }
    },
    methods: {
        refresh: function () {
            this.isLoading = true;
            axios.get('/ajax/provider/contacts')
                .then(response => {
                    this.contacts = response.data
                    this.isLoading = false;
                })
                .catch(error => {
                    let message = error.response;
                    toastr['error'](message, 'Error', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                    this.isLoading = false;
                });
        },
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-contact-confirmation', id);
        },
        deleteContact: function (id) {
            axios.delete('/ajax/provider/contacts/' + id)
                .then(response => {
                    this.refresh();
                })
                .catch(error => {
                    let message = error.response;
                    toastr['error'](message, 'Error', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                    this.isLoading = false;
                });
        }
    },
    created() {
        this.refresh();
    }
}
</script>

<style scoped>

</style>